const EXCEL_GUARDED = /^="((?:[^"]|"")*)"$/;

/** Exports wrap Excel-unsafe cells as ="...", so strip that before anything reads the value. */
export const unwrapExcelSafeCell = (value: string): string => {
  const match = EXCEL_GUARDED.exec(value);
  return match ? match[1].replace(/""/g, '"') : value;
};
